import { createAppSlice } from '../app.slice';

const initialState = {
  data: [],
  selectedAccount: null,
};

export const userSecuritiesAccountsSlice = createAppSlice({
  name: 'userSecuritiesAccountsSlice',
  initialState,
  reducers: {
    userSecuritiesAccountsRequest: (state) => state,
    userSecuritiesAccountsSucess: (state, action) => {
      if (state.data.length === 0 && action.payload.length > 0) {
        const visibleAccounts = action.payload.filter(
          (account) => account.visible === 'Y',
        );

        const favoriteAccount = visibleAccounts.find(
          (account) => account.favorite === 'Y',
        );

        if (favoriteAccount) {
          state.selectedAccount = favoriteAccount.account;
        } else {
          state.selectedAccount = visibleAccounts[0].account;
        }
      }

      state.data = action.payload;
    },
    userSecuritiesAccountsFailure: (state) => state,
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
    setSelectedAccountFavorite: (state) => {
      const { account } =
        state.data.find((el) => el.favorite === 'Y') ?? state.data[0];
      state.selectedAccount = account;
    },
  },
});
